export const WARRANTY_CAR_MODELS = [
  "Camry",
  "Corolla",
  "RAV4",
  "Land Cruiser",
  "Hilux",
  "Yaris",
];

export type WarrantyPdfType = "standard" | "extended";

export const getWarrantyPdfStorageKey = (
  brand: string,
  model: string,
  type: WarrantyPdfType,
  isDefault = false
): string => {
  if (isDefault) {
    return `warranty_pdf_${brand}_default_${type}`;
  }
  return `warranty_pdf_${brand}_${model}_${type}`;
};
